import { graphql } from '@/generated/gql';

export const TESSERACT_DEMAND_ITEM_QUERY = graphql(/* GraphQL */ `
  query TesseractDemandItem($filter: TsrctQueryBuilderQuery) {
    tesseract {
      demands(filter: $filter, limit: 1) {
        nodes {
          id
          sequenceNumber
        }
      }
    }
  }
`);
